import styled from "styled-components";

interface ButtonProps {
    readonly yellow?: boolean;
    readonly green?: boolean;
    small?: boolean;
}

export const GreenButton = styled.button`
    background: linear-gradient(0deg, #629361, #629361), #009688;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
    border-radius: 10px;
    height: 36px;
    width: 88px;
    color: white;
    font-size: 12px;
    align-self: flex-end;
    cursor: pointer;

    :hover {
        filter: brightness(120%);
    }
`;

export const RedButton = styled.button<ButtonProps>`
    background: ${(props) =>
        props["yellow"]
            ? "linear-gradient(0deg, #FFA620, #FFA620), #009688"
            : props["green"]
            ? "linear-gradient(0deg, #4B975C, #4B975C), #009688"
            : "linear-gradient(0deg, #BD3636, #BD3636), #009688"};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
    border-radius: 10px;
    height: ${(props) => (props.small ? "28px" : "36px")};
    width: 88px;
    color: white;
    font-size: 12px;
    align-self: flex-end;

    :hover {
        filter: brightness(120%);
    }
`;


export const WhiteButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    height: 36px;
    font-size: 12px;
    align-self: flex-end;

    :hover {
        cursor: pointer;
    }

    color: #629361;

    background: linear-gradient(0deg, #ffffff, #ffffff), #009688;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);

    :hover {
        filter: brightness(120%);
    }
`;
